import { Icon } from '@aibees/shared/components/icon';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Icon)``;
